// Mock data for ADIPSI website

export const heroImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&h=600&fit=crop",
    alt: "Rapat Kerja Nasional",
    caption: "Rapat Kerja Nasional"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?w=800&h=600&fit=crop",
    alt: "Penandatangan MoU",
    caption: "Penandatangan MoU"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=600&fit=crop",
    alt: "Kegiatan ADIPSI",
    caption: "Kegiatan ADIPSI"
  }
];

export const activities = [
  {
    id: 1,
    title: "Rapat Koordinasi Pengurus ADIPSI 2024",
    image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=600&h=400&fit=crop",
    date: "15 Januari 2024",
    description: "Rapat koordinasi pengurus ADIPSI membahas program kerja tahun 2024"
  },
  {
    id: 2,
    title: "Seminar Nasional Ilmu Pemerintahan",
    image: "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=600&h=400&fit=crop",
    date: "20 Februari 2024",
    description: "Seminar nasional dengan tema Transformasi Digital dalam Pemerintahan"
  },
  {
    id: 3,
    title: "Workshop Penelitian dan Publikasi Ilmiah",
    image: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=600&h=400&fit=crop",
    date: "10 Maret 2024",
    description: "Workshop peningkatan kapasitas dosen dalam penelitian dan publikasi"
  },
  {
    id: 4,
    title: "Kunjungan Kerja ke Lembaga Pemerintahan",
    image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=600&h=400&fit=crop",
    date: "25 Maret 2024",
    description: "Kunjungan kerja untuk memperkuat kerjasama dengan lembaga pemerintahan"
  }
];

export const partners = [
  {
    id: 1,
    name: "Universitas Indonesia",
    logo: "https://upload.wikimedia.org/wikipedia/id/thumb/0/0f/Makara_of_Universitas_Indonesia.svg/200px-Makara_of_Universitas_Indonesia.svg.png",
    location: "Jakarta"
  },
  {
    id: 2,
    name: "Universitas Lampung",
    logo: "https://upload.wikimedia.org/wikipedia/id/thumb/6/64/UNILA.png/200px-UNILA.png",
    location: "Lampung"
  },
  {
    id: 3,
    name: "Universitas Muhammadiyah Malang",
    logo: "https://upload.wikimedia.org/wikipedia/id/thumb/9/94/Logo_UMM.png/200px-Logo_UMM.png",
    location: "Malang"
  },
  {
    id: 4,
    name: "Universitas Brawijaya",
    logo: "https://upload.wikimedia.org/wikipedia/id/thumb/5/5c/Universitas_Brawijaya_logo.png/200px-Universitas_Brawijaya_logo.png",
    location: "Malang"
  },
  {
    id: 5,
    name: "Universitas Diponegoro",
    logo: "https://upload.wikimedia.org/wikipedia/id/thumb/7/71/Lambang_UNDIP.png/200px-Lambang_UNDIP.png",
    location: "Semarang"
  },
  {
    id: 6,
    name: "Universitas Padjadjaran",
    logo: "https://upload.wikimedia.org/wikipedia/id/thumb/4/4e/Lambang_Unpad.svg/200px-Lambang_Unpad.svg.png",
    location: "Bandung"
  }
];

export const navItems = [
  { label: "BERANDA", href: "#hero" },
  { label: "TENTANG KAMI", href: "#about" },
  { label: "KEGIATAN", href: "#kegiatan" },
  { label: "MITRA ADIPSI", href: "#mitra" },
  { label: "GALERI", href: "#gallery" },
  { label: "KONTAK", href: "#contact" }
];

export const galleryPhotos = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&h=600&fit=crop",
    title: "Rapat Koordinasi Nasional",
    category: "Rapat"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=800&h=600&fit=crop",
    title: "Seminar Nasional",
    category: "Seminar"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=800&h=600&fit=crop",
    title: "Workshop Dosen",
    category: "Workshop"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=600&fit=crop",
    title: "Kegiatan Lapangan",
    category: "Kegiatan"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=800&h=600&fit=crop",
    title: "Kunjungan Kerja",
    category: "Kunjungan"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?w=800&h=600&fit=crop",
    title: "Penandatanganan MoU",
    category: "Kerjasama"
  },
  {
    id: 7,
    url: "https://images.unsplash.com/photo-1591115765373-5207764f72e7?w=800&h=600&fit=crop",
    title: "Diskusi Panel",
    category: "Diskusi"
  },
  {
    id: 8,
    url: "https://images.unsplash.com/photo-1559223607-9a43f01e779d?w=800&h=600&fit=crop",
    title: "Konferensi Internasional",
    category: "Konferensi"
  }
];
